import { TaskVariant } from './task_template_variant';
import { Topology } from './task_template_topology';
import { Slot } from './task_template_slot';
export class TaskTemplate {
    name :string=""
    parts :Slot[]=[new Slot()]
    layouts :Topology[]= [new Topology()]
    variants: TaskVariant[]=[]

}
